// https://segmentfault.com/a/1190000009733948
import ToastDialog from './ToastDialog.vue'
var Toast = {} // 定义插件对象
Toast.install = function (Vue, options) { // vue的install方法，用于定义vue插件
  //
  const ToastController = Vue.extend(ToastDialog)

  let instance = null
  let toastTimer = null
  let duration = 1000

  // 实现toast的关闭方法
  ToastController.prototype.close = function () {
    this.show = false
  }

  // 在Vue原型实现toast的DOM挂载、以及功能实现
  // 用户可以在Vue实例（Vue单文件就是一个Vue实例）通过this.$toast来访问以下内容
  Vue.prototype.$toast = {
    info: (option = {}) => {
      if (toastTimer) {
        // 如果toast还在，则取消上次消失时间
        clearTimeout(toastTimer)
        if (instance) {
          instance.show = false
        }
      }
      if (!instance) {
        instance = new ToastController().$mount(document.createElement('div'))
        duration = typeof option === 'object' ? option.duration : 1000
        // 将toast的DOM挂载到body上
        document.body.appendChild(instance.$el)
      }

      instance.show = true
      instance.message = typeof option === 'string' ? option : option.message
      // 自动关闭功能的实现
      toastTimer = setTimeout(function () {
        instance.close()
      }, duration)
      return instance
    }
  }
}
export default Toast
// 导出Toast（注意：此处不能用module exports导出，在一个文件中，不能同时使用require方式引入，而用module exports导出，两种方式不能混用）



// WEBPACK FOOTER //
// ./src/components/ToastDialog.js